import { render, staticRenderFns } from "./new_post.vue?vue&type=template&id=24b66309&scoped=true&"
import script from "./new_post.vue?vue&type=script&lang=js&"
export * from "./new_post.vue?vue&type=script&lang=js&"
import style0 from "./new_post.vue?vue&type=style&index=0&id=24b66309&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b66309",
  null
  
)

export default component.exports